// extracted by mini-css-extract-plugin
export default {"buttons":"buttons--BtMQV","start":"start--nvP7L","center":"center--XjFi4","between":"between--A7Erc","end":"end--VcqwG","push":"push--cCcJn"};